import {
  useState, createContext, useMemo,
} from 'react';
import { LayoutContextType, ProviderPropsType } from 'contexts/types';
import { BrandSettings, PartnerSettings, Settings } from 'router/types';

export const LayoutContext = createContext<LayoutContextType>({
  partnerSettings: undefined,
  setPartnerSettings: () => {},
  brandSettings: undefined,
  setBrandSettings: () => {},
  showConversion: false,
  setShowConversion: () => {},
  timeZoneSettings: undefined,
  setTimeZoneSettings: () => {},
  hideLayout: false,
  setHideLayout: () => {},
});

export const LayoutProvider = ({ children }: ProviderPropsType) => {
  const [partnerSettings, setPartnerSettings] = useState<PartnerSettings>();
  const [brandSettings, setBrandSettings] = useState<BrandSettings>();
  const [showConversion, setShowConversion] = useState<boolean>(false);
  const [timeZoneSettings, setTimeZoneSettings] = useState<Settings>();
  const [hideLayout, setHideLayout] = useState<boolean>(false);

  const value = useMemo(
    () => ({
      partnerSettings,
      setPartnerSettings,
      brandSettings,
      setBrandSettings,
      showConversion,
      setShowConversion,
      timeZoneSettings,
      setTimeZoneSettings,
      hideLayout,
      setHideLayout,
    }),
    [partnerSettings, brandSettings, showConversion, timeZoneSettings, hideLayout],
  );

  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
};
